const storiesThumbnailSize = {
  PRIMARY: '105px',
  SECONDARY: '108px',
}

export { storiesThumbnailSize }
